import { useState, useEffect } from 'react';
import { format } from 'date-fns';

export const LiveClock = () => {
  const [time, setTime] = useState(new Date());

  useEffect(() => {
    const timerId = setInterval(() => {
      setTime(new Date());
    }, 1000); // Update every second

    return () => {
      clearInterval(timerId);
    };
  }, []);

  return (
    <div className="text-center font-mono text-xs text-glass-400 tabular-nums leading-tight">
      <div>{format(time, 'HH:mm:ss')}</div>
      <div className="text-glass-500">{format(time, 'dd/MM/yy')}</div>
    </div>
  );
};
